import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import lang from '../../constants/Languages.js';

//import components
import HeadingsStrucutreListItem from './HeadingsStrucutreListItem.js';

const HeadingsStrucutre = ({ clang, data, getHeadingChildren, getFieldChildren, isError, isLoading }) => {
    return (
        <div className="headings-structure">
            <h4 className="headings-structure__header" dangerouslySetInnerHTML={{__html: lang[clang].characteristics.headings_structure}}></h4>
            <ul className="headings-structure__list">
                {data && data.map((heading) =>
                    <HeadingsStrucutreListItem
                        key={heading.domainCode}
                        {...heading}
                        isLoading={!!isLoading[heading.domainCode]}
                        isError={!!isError[heading.domainCode]}
                        getHeadingChildren={getHeadingChildren}
                        getFieldChildren={getFieldChildren}/>)}
            </ul>
        </div>
    );
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
});

export default withRouter(connect(mapStateToProps)(HeadingsStrucutre));



// WEBPACK FOOTER //
// ./src/components/characteristics/HeadingsStrucutre.js